<template>
  <div>
    <div v-if="jkkp === 6">
      <!-- JKKP 6 Form -->
      <h4 class="info-text">JKKP 6 Form</h4>
      <div class="row">
        <div class="col-lg-6">
          <h4 class="info-text">BAHAGIAN A - Maklumat Pemberitahu</h4>
          <div class="row justify-content-center">
            <div class="col-sm-10">
              <div class="row">
                <div class="col-md-6">
                  <base-input @change="detectUpdate" label="Nama" v-model="notifier.name"></base-input>
                </div>
                <div class="col-md-6">
                  <base-input @change="detectUpdate" label="Jawatan" v-model="notifier.designation"></base-input>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-lg-12">
                      <base-input
                        @change="detectUpdate"
                        label="Nama Organisasi"
                        v-model="notifier.org"
                      ></base-input>
                      <base-input
                        @change="detectUpdate"
                        label="No Telefon"
                        v-model="notifier.phoneno"
                      ></base-input>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <base-input label="Alamat Organisasi">
                    <textarea class="address" @change="detectUpdate" v-model="notifier.add"></textarea>
                  </base-input>
                </div>
                <div class="col-md-6">
                  <base-input @change="detectUpdate" label="No. ROC" v-model="notifier.roc"></base-input>
                </div>
                <div class="col-md-6">
                  <base-input
                    @change="detectUpdate"
                    label="No. Pend. JKKP"
                    v-model="notifier.jkkpregno"
                  ></base-input>
                </div>
                <div class="col-lg-12">
                  <base-input label="Orang yang boleh dihubungi">
                    <textarea @change="detectUpdate" class="address" v-model="notifier.other"></textarea>
                  </base-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6" style="border-left: solid red; padding-bottom: 1%">
          <h4 class="info-text">BAHAGIAN B - Orang Yang Terlibat</h4>
          <div class="row justify-content-center">
            <div class="col-sm-10">
              <div class="row">
                <div class="col-md-6">
                  <base-input @change="detectUpdate" label="Nama" v-model="victim.name"></base-input>
                </div>
                <div class="col-md-6">
                  <base-input  label="Tarikh Lahir" >
                    <el-date-picker @change="detectUpdate" v-model="victim.dob" type="date"></el-date-picker>
                  </base-input>
                </div>
                <div class="col-md-6">
                  <base-input @change="detectUpdate" label="No K/P" v-model="victim.kp"></base-input>
                </div>
                <div class="col-md-6">
                  <base-input @change="detectUpdate" label="No Pekerja" v-model="victim.nopekerja"></base-input>
                </div>
                <div class="col-md-4">
                  <base-input
                    @change="detectUpdate"
                    label="Warganegara"
                    v-model="victim.nationality"
                  ></base-input>
                </div>
                <div class="col-md-4">
                  <base-input @change="detectUpdate" label="Jantina" v-model="victim.gender"></base-input>
                </div>
                <div class="col-md-4">
                  <base-input @change="detectUpdate" label="Pekerjaan" v-model="victim.occupation"></base-input>
                </div>
                <div class="col-md-6">
                  <base-input label="Tempat Kejadian">
                    <textarea @change="detectUpdate" class="address" v-model="inLocation"></textarea>
                  </base-input>
                </div>
                <div class="col-md-6">
                  <base-input label="Alamat Organisasi">
                    <textarea @change="detectUpdate" class="address" v-model="victim.orgaddr"></textarea>
                  </base-input>
                </div>
                <div class="col-md-6">
                  <base-input
                    label="Tarikh Kejadian"
                  >
                    <el-date-picker @change="detectUpdate" v-model="victim.intimestamp" type="date"></el-date-picker>
                  </base-input>
                    
                  <base-input label="Masa Kejadian">
                  <!-- selectableRange: '00:00:00 - 23:59:59' -->
                    <el-time-picker 
                      v-model="inTime" @change="detectUpdate"
                      value-format="HH:mm:ss"
                      :picker-options="{
                        format: 'hh:mm:ss'
                      }"></el-time-picker>
                  </base-input>
                </div>
                <div class="col-md-6">
                  <base-input
                    label="Tarkih Mula Lapor kepada JKKP"
                  >
                    <el-date-picker @change="detectUpdate" v-model="victim.reportdate" type="date"></el-date-picker>
                  </base-input>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <!-- JKKP 7 Form -->
      <h4 class="info-text">JKKP 7 Form</h4>
      <div class="row">
        <div class="col-lg-6">
          <h4 class="info-text">BAHAGIAN A1 - Pemberitahuan - Peraturan 7 (1)</h4>
          <div class="row justify-content-center">
            <div class="col-sm-10">
              <div class="row">
                <div class="col-md-6">
                  <base-input label="Nama" v-model="notifier.name" @change="detectUpdate"></base-input>
                </div>
                <div class="col-md-6">
                  <base-input label="Jawatan" v-model="notifier.designation" @change="detectUpdate"></base-input>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-lg-12">
                      <base-input
                        label="Nama Organisasi"
                        v-model="notifier.org"
                        @change="detectUpdate"
                      ></base-input>
                      <base-input
                        label="No Telefon"
                        v-model="notifier.phoneno"
                        @change="detectUpdate"
                      ></base-input>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <base-input label="Alamat Organisasi">
                    <textarea class="address" v-model="notifier.add" @change="detectUpdate"></textarea>
                  </base-input>
                </div>
                <div class="col-md-6">
                  <base-input label="No. ROC" v-model="notifier.roc" @change="detectUpdate"></base-input>
                </div>
                <div class="col-md-6">
                  <base-input label="JKKP" v-model="notifier.jkkpregno" @change="detectUpdate"></base-input>
                </div>
                <div class="col-lg-12">
                  <base-input label="Orang yang boleh dihubungi">
                    <textarea class="address" v-model="notifier.other" @change="detectUpdate"></textarea>
                  </base-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6" style="border-left: solid red; padding-bottom: 1%">
          <h4
            class="info-text"
          >BAHAGIAN A2 - Pemberitahuan - Peraturan 7 (2) Pengamal Perubatan Berdaftar</h4>
          <div class="row justify-content-center">
            <div class="col-sm-10">
              <div class="row">
                <div class="col-md-6">
                  <base-input label="Nama" v-model="medic.name" @change="detectUpdate"></base-input>
                </div>
                <div class="col-md-6">
                  <base-input label="Jawatan" v-model="medic.designation" @change="detectUpdate"></base-input>
                </div>
                <div class="col-md-6">
                  <base-input label="No Telefon" v-model="medic.telno" @change="detectUpdate"></base-input>
                </div>
                <div class="col-md-6">
                  <base-input label="Alamat Klinik / Hospital">
                    <textarea class="address" v-model="medic.addr" @change="detectUpdate"></textarea>
                  </base-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12" style="border-top: solid red; padding-bottom: 1%">
          <h4 class="info-text">BAHAGIAN B - Orang Yang Terlibat</h4>
          <div class="row justify-content-center">
            <div class="col-sm-10">
              <div class="row">
                <div class="col-md-6">
                  <base-input label="Nama" v-model="victim.name" @change="detectUpdate"></base-input>
                </div>
                <div class="col-md-6">
                  <base-input  label="Tarikh Lahir" >
                    <el-date-picker @change="detectUpdate" v-model="victim.dob" type="date"></el-date-picker>
                  </base-input>
                </div>
                <div class="col-md-4">
                  <base-input
                    label="No K/P atau No. Passport"
                    v-model="victim.kp"
                    @change="detectUpdate"
                  ></base-input>
                </div>
                <div class="col-md-4">
                  <base-input label="No Pekerja" v-model="victim.nopekerja" @change="detectUpdate"></base-input>
                </div>
                <div class="col-md-4">
                  <base-input
                    label="Warganegara"
                    v-model="victim.nationality"
                    @change="detectUpdate"
                  ></base-input>
                </div>
                <div class="col-md-4">
                  <base-input label="Jantina" v-model="victim.gender" @change="detectUpdate"></base-input>
                </div>
                <div class="col-md-4">
                  <base-input label="Pekerjaan" v-model="victim.occupation" @change="detectUpdate"></base-input>
                </div>
                <div class="col-md-4">
                  <base-input label="Nama Organisasi" v-model="victim.org" @change="detectUpdate"></base-input>
                </div>
                <div class="col-md-6">
                  <base-input label="Alamat Organisasi">
                    <textarea class="address" v-model="victim.orgaddr" @change="detectUpdate"></textarea>
                  </base-input>
                </div>
                <div class="col-md-6">
                  <base-input label="Lokasi Kejadian">
                    <textarea class="address" v-model="inLocation" @change="detectUpdate"></textarea>
                  </base-input>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Option, Select, DatePicker, TimePicker, TimeSelect } from "element-ui";
import moment, { utc } from "moment";
import swal from "sweetalert2";

export default {
  props: ["parentData"],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [TimePicker.name]: TimePicker,
  },
  props: ["test1"],
  data() {
    return {
      value1: "",
      tableSiteRoute: [
        {
          siteRoute: "Route A"
        },
        {
          siteRoute: "Route B"
        }
      ],
      selects: {
        condition: [
          { value: "operational", label: "Operational" },
          { value: "Not operational", label: "Not Operational" }
        ]
      },
      model: {
        file: null
      },
      idrecord: "",
      notifier: {
        name: "",
        designation: "",
        org: "",
        phoneno: "",
        add: "",
        roc: "",
        jkkpregno: "",
        other: ""
      },
      victim: {
        name: "",
        dob: "",
        kp: "",
        org: "",
        nopekerja: "",
        nationality: "",
        gender: "",
        occupation: "",
        inlocation: "",
        orgaddr: "",
        intimestamp: "",
        reportdate: ""
      },
      medic: {
        name: "",
        designation: "",
        telno: "",
        addr: ""
      },
      doc: {
        diagnosis: "",
        diagnosis_date: "",
        name: "",
        addr: ""
      },
      indetails: "",
      inTime: "",
      inLocation: "",
      jkkp: "",
      firstStepData: []
    };
  },
  created() {
    // this.passFirstStep();
  },
  mounted() {
    this.$root.$on("update", row => {
      // do your thing
      // console.log(row.jkkp);
      console.log(row)
      this.jkkp = row.jkkp;
      // console.log(this.jkkp);
      this.idrecord = row.incidentId;
      this.notifier.name = row.notifierName;
      this.notifier.designation = row.notifierDesignation;
        this.notifier.org = row.notifierOrg;
        this.notifier.phoneno = row.notifierTelNo;
        this.notifier.add = row.notifierAddr;
        this.notifier.roc = row.notifierRocNo;
        this.notifier.jkkpregno = row.notifierJkkpRegNo;
        this.notifier.other = row.otherContact;

      this.victim.name = row.personInvolved;
        this.victim.dob = row.vicDob;
        this.victim.kp = row.vicKp;
        this.victim.nopekerja = row.NoPekerja;
        this.victim.nationality = row.vicNation;
        this.victim.gender = row.vicSex;
        this.victim.occupation = row.vicOccupation;
        this.victim.inlocation = row.incidentLocation;
        this.victim.orgaddr = row.vicCompAddr;
        this.victim.intimestamp = row.dateOfIncident;
        this.victim.reportdate = row.reportDateToJkkp;
        this.victim.org = row.vicOrg;
        this.inTime = row.inTime;
        // console.log(this.inTime)
        // console.log(row.inTime)
        this.inLocation = row.inLocation;
        this.indetails = row.inDetail;

      this.medic.name = row.medicName;
      this.medic.designation = row.medicDesignation;
      this.medic.telno = row.medicTelNo;
      this.medic.addr = row.medicAddr;
      // console.log(this.medic.name, this.medic.designation, this.medic.telno, this.medic.addr)

      this.doc.diagnosis = row.diagnosis;
      this.doc.diagnosis_date = row.diagnosisDate;
      this.doc.name = row.doctorName;
      this.doc.addr = row.doctorAddr;
    });
  },
  methods: {
    onFileChange(file) {
      this.file = file;
      // console.log(this.file)
    },
    validate() {
      this.$emit("on-validated", true, this.model);
      return Promise.resolve(true);
    },
    detectUpdate() {
      console.log(this.victim.dob);
      console.log(this.victim.reportdate);
      console.log(this.victim.intimestamp);
      console.log(this.inTime)

      let dob = moment(this.victim.dob).format("YYYY-MM-DD")
      let reportdate = moment(this.victim.reportdate).format("YYYY-MM-DD")
      let incidentdate = moment(this.victim.intimestamp).format("YYYY-MM-DD")
      let inTime = moment(this.inTime).format("HH:mm:ss")
      console.log(dob)
      console.log(reportdate)
      console.log(incidentdate)
      console.log(this.notifier.name);
      console.log(this.notifier.designation);
      console.log(this.notifier.org);

      let data = {
        jkkp: this.jkkp,
        dateOfIncident: incidentdate,
        incidentId: this.idrecord,
        notifierName: this.notifier.name,
        personInvolved: this.victim.name,
        notifierDesignation: this.notifier.designation,
        notifierOrg: this.notifier.org,
        notifierAddr: this.notifier.add,
        notifierTelNo: this.notifier.phoneno,
        notifierRocNo: this.notifier.roc,
        notifierJkkpRegNo: this.notifier.jkkpregno,
        otherContact: this.notifier.other,

        vicDob: dob,
        vicKp: this.victim.kp,
        NoPekerja: this.victim.nopekerja,
        vicNation: this.victim.nationality,
        vicSex: this.victim.gender,
        vicOccupation: this.victim.occupation,
        vicOrg: this.victim.org,

        // incidentLocation: this.victim.inlocation,
        vicCompAddr: this.victim.orgaddr,
        reportDateToJkkp: reportdate,

        inDetail: this.indetails,
        inTime: this.inTime,
        inLocation: this.inLocation,

        medicName: this.medic.name,
        medicDesignation: this.medic.designation,
        medicTelNo: this.medic.telno,
        medicAddr: this.medic.addr,

        docDiagnosis: this.doc.diagnosis,
        docDiagnosisDate: this.doc.diagnosis_date,
        docName: this.doc.name,
        docAddr: this.doc.addr
      };
      var arr = [];
      arr.push(data);
      console.log(arr);
      if(this.inTime == null){
        swal({
          title: "Data Error!",
          text: "Masa kejadian tidak diisi",
          type: "warning",
          confirmButtonClass: "btn btn-success btn-fill",
          confirmButtonText: "Okay",
          buttonsStyling: false
        });
      } else {
        this.passFirstStep(arr);
      }
    },
    passFirstStep(data) {
      this.$root.$emit("senddata", data);
      // console.log(this.parentData)

      // var storedFirstData = JSON.parse(localStorage.getItem("firststep"));
      // console.log(storedFirstData)

      // this.notifier.name = storedFirstData.notifierName
      // this.firstStepData.push(e)
      // console.log(this.firstStepData)
    }
  }
};
</script>
<style scoped>
textarea {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 1px solid #2b3553;
  border-radius: 4px;
  background-color: transparent;
  font-size: 14px;
  resize: none;
  /* color: #1d253b; */
}

textarea:focus {
  outline: none !important;
  border: 1px solid #1d8cf8;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,
    background-color 0.3s ease-in-out;
}


.address {
  width: 100%;
  height: 100px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}

.huraian {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}
</style>
